import type { FunctionComponent, ChangeEvent } from 'react';
import { useCallback } from 'react';

import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Icon } from '../../../shared/components/icon/icon';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './currency-selector.module.scss';

const style = createStyleHelper(styles, 'currency-selector');

export interface ICurrencySelectorProps {
    className?: string;
    onCurrencyChange: (currency: string) => void;
    currencies: string[];
    value: string;
}

export const CurrencySelector: FunctionComponent<ICurrencySelectorProps> = ({
    className,
    onCurrencyChange,
    currencies,
    value,
}) => {
    const handleChange = useCallback(
        (ev: ChangeEvent<HTMLSelectElement>) => {
            onCurrencyChange(ev.target.value);
        },
        [onCurrencyChange],
    );

    return (
        <div className={createClassName([style(), className])}>
            <select onChange={handleChange} value={value} className={style('selector')}>
                {currencies.map((currency) => (
                    <option key={currency} value={currency}>
                        <FormattedMessage
                            id={`top-navigation.balance.currency.${currency}`}
                            defaultMessage={currency}
                        />
                    </option>
                ))}
            </select>
            <Icon className={style('icon')} name={'angle-down'} />
        </div>
    );
};
